<template>
  <div>
    <div class="filtered-result-wrap mobile-responsive">
      <div class="filtered-result-list">
        <ResultListItem
          v-for="student in studentList"
          :key="student.studentId"
          :student="student"
          @select-student="selectStudent"
          @showStudentInfo="showStudentInfo"
        />
      </div>
    </div>
    <Pagination
      v-if="pagination.totalItemCount > 1"
      id="pgStudentList"
      :data="pagination"
      @pagination-go-page="goToPage"
    />
  </div>
</template>

<script>
import ResultListItem from './ResultListItem';
import Pagination from '@/components/common/Pagination';
// import Filters from "./Filters";
export default {
  components: {
    ResultListItem,
    Pagination,
    // Filters
  },
  data() {
    return {};
  },
  props: {
    studentList: {
      type: Array,
    },
    pagination: {
      type: Object,
      default() {
        return {
          currentPage: 1,
          totalItemCount: 1,
          pageCount: 1,
        };
      },
    },
  },
  methods: {
    selectStudent(student) {
      this.$emit('select-student', student);
    },
    goToPage(pageNumber) {
      this.$emit('pagination-go-page', pageNumber);
    },
    showStudentInfo(student) {
      this.$emit('showStudentInfo', student);
    },
  },
};
</script>
